/**
 * @param data [event, eventCategory, eventAction, eventLabel]
 */
export function trackWithGoogleTagManager(
  data: [string, string, string, string]
);
export function trackWithGoogleTagManager(data: {
  event: string;
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
});
export function trackWithGoogleTagManager(
  data:
    | [string, string, string, string]
    | {
        event: string;
        eventCategory: string;
        eventAction: string;
        eventLabel: string;
      }
) {
  if (typeof window !== "undefined" && window.dataLayer) {
    try {
      let trackData = [];
      if ("event" in data) {
        trackData.push(data.event);
        trackData.push(data.eventCategory);
        trackData.push(data.eventAction);
        trackData.push(data.eventLabel);
      } else {
        trackData = [...data];
      }

      window.dataLayer.push({
        event: trackData[0],
        eventCategory: trackData[1],
        eventAction: trackData[2],
        eventLabel: trackData[3],
      });
    } catch (error) {
      console.error(error);
    }
  }
}

declare global {
  interface Window {
    dataLayer: any[];
  }
}
